import logo365Light from "../obr/banky/365.png";
import logo365Dark from "../obr/banky/365_2.png";
import logoBKS from "../obr/banky/BKS.png";
import logoCSOB from "../obr/banky/CSOB.png";
import logoMBank from "../obr/banky/mbank.png";
import logoPRIMA from "../obr/banky/PRIMA.PNG";
import logoSLSP from "../obr/banky/SLSP.png";
import logoTB from "../obr/banky/TB.png";
import logoUCBLight from "../obr/banky/UCB4.png";
import logoUCBDark from "../obr/banky/UCB2.png";
import logoVUBLight from "../obr/banky/VUB.png";
import logoVUBDark from "../obr/banky/VUB3.png";

const MAPA_LOG_BANK = {
   "365": {
    src: logo365Light,
    srcDark: logo365Dark,
    variant: "wide",
    fit: "contain",
    sirka: "52px",
    vyska: "22px",
  },
  BKS: {
    src: logoBKS,
    variant: "wide",
    fit: "contain",
    sirka: "44px",
    vyska: "16px",
  },
  CSOB: {
    src: logoCSOB,
    variant: "badge",
    fit: "contain",
    sirka: "36px",
    vyska: "22px",
  },
  mBank: {
    src: logoMBank,
    variant: "wide",
    fit: "contain",
    sirka: "64px",
    vyska: "28px",
  },
  PRIMA: {
    src: logoPRIMA,
    variant: "wide",
    fit: "contain",
    sirka: "74px",
    vyska: "22px",
  },
  SLSP: {
    src: logoSLSP,
    variant: "wide",
    fit: "contain",
    sirka: "54px",
    vyska: "20px",
  },
  TB: {
    src: logoTB,
    variant: "tall",
    fit: "contain",
    sirka: "36px",
    vyska: "22px",
  },
  UCB: {
    src: logoUCBLight,
    srcDark: logoUCBDark,
    variant: "wide",
    fit: "contain",
    sirka: "74px",
    vyska: "22px",
  },
  VUB: {
    src: logoVUBLight,
    srcDark: logoVUBDark,
    variant: "wide",
    fit: "contain",
    sirka: "74px",
    vyska: "22px",
  },
};

export function ziskajLogoBanky(bankaKod) {
  if (!bankaKod) return null;
  return MAPA_LOG_BANK[String(bankaKod)] || null;
}

export function ziskajStylLogaBanky(logoBanky) {
  if (!logoBanky) return undefined;

  return {
    width: logoBanky.sirka || undefined,
    height: logoBanky.vyska || undefined,
  };
}